import HttpService from '@/endpoints/HttpService';
import {
  LockerRoomDrawingWallTransformBatchRequest,
  LockerRoomDrawingWall,
  LockerRoomDrawingWallRequest,
  LockerRoomDrawingWallUpdateRequest,
} from '@/models/lockers/lockerRoomDrawingWall';

const baseUrl = `${process.env.VUE_APP_API_PREFIX}LockerRoomDrawingWalls`;

export default class LockerRoomDrawingWallsService {
  public static async getWallsForRoom(roomId: string): Promise<LockerRoomDrawingWall[]> {
    const response = await HttpService.get(`${baseUrl}/${roomId}`);
    return response.data.entities;
  }

  public static async createWall(request: LockerRoomDrawingWallRequest): Promise<LockerRoomDrawingWall[]> {
    const response = await HttpService.post(baseUrl, request);
    return response.data.entities;
  }

  public static async deleteWall(wallId: number): Promise<LockerRoomDrawingWall[]> {
    const response = await HttpService.delete(`${baseUrl}/${wallId}`);
    return response.data.entities;
  }

  public static async duplicateWall(wallId: number): Promise<LockerRoomDrawingWall[]> {
    const response = await HttpService.post(`${baseUrl}/${wallId}/duplicate`);
    return response.data.entities;
  }

  public static async updateWall(
    wallId: number,
    request: LockerRoomDrawingWallUpdateRequest
  ): Promise<LockerRoomDrawingWall[]> {
    const response = await HttpService.put(`${baseUrl}/${wallId}`, request);
    return response.data.entities;
  }

  public static async updateWallTransforms(request: LockerRoomDrawingWallTransformBatchRequest): Promise<void> {
    await HttpService.put(baseUrl, request);
  }
}
